var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChiffreAffaireIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 102.838,
    height: 90.061,
    viewBox: "0 0 102.838 90.061",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_325",
    x: 14.489,
    y: 0,
    width: 88.349,
    height: 62.913,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_326",
    x: 0,
    y: 27.159,
    width: 88.099,
    height: 62.902,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_327",
    x: 26.947,
    y: 20.901,
    width: 48.909,
    height: 48.238,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_257",
    "data-name": "Groupe 257",
    transform: "translate(2355.411 1377.704)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -2355.41, -1377.7)",
    filter: "url(#Trac\\xE9_325)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_325-2",
    "data-name": "Trac\\xE9 325",
    d: "M-2218.709-1342.435c-.367.659-.546,1.032-.771,1.375q-4.322,6.6-8.657,13.2c-.939,1.427-1.14,1.426-2.065.018q-4.367-6.648-8.716-13.308a5.363,5.363,0,0,1-.418-1.128,5.116,5.116,0,0,1,1.15-.29c1.837-.031,3.677-.014,5.777-.014-.465-1.4-.806-2.6-1.253-3.755a29.609,29.609,0,0,0-49.055-9.721,6.946,6.946,0,0,1-2.151,1.671,3.027,3.027,0,0,1-3.647-1.248,3.209,3.209,0,0,1,.418-4.064,34.914,34.914,0,0,1,10.892-8.275,35.987,35.987,0,0,1,51.083,24.369c.177.761.481,1.053,1.263,1.029,1.514-.048,3.031-.023,4.546-.007C-2219.878-1342.582-2219.441-1342.507-2218.709-1342.435Z",
    transform: "translate(2312.55 1377.7)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -2355.41, -1377.7)",
    filter: "url(#Trac\\xE9_326)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_326-2",
    "data-name": "Trac\\xE9 326",
    d: "M-2332.876-1248.405a28.118,28.118,0,0,0,3.275,8.214c4.379,6.9,10.384,11.717,18.4,13.568,11.155,2.575,20.789-.412,28.786-8.6.92-.942,1.848-1.769,3.253-1.565a3.085,3.085,0,0,1,2.631,2.077,3.22,3.22,0,0,1-.787,3.485,36.24,36.24,0,0,1-14.028,9.6,35.345,35.345,0,0,1-16.61,2.123,35.96,35.96,0,0,1-31.233-27.672c-.237-1.019-.646-1.28-1.6-1.239-1.512.063-3.029.034-4.543.01-1.173-.019-1.35-.3-.739-1.238q4.514-6.923,9.069-13.82c.65-.985,1.005-.964,1.648.015q4.429,6.75,8.843,13.51a6.055,6.055,0,0,1,.468,1.234,6.324,6.324,0,0,1-1.282.29C-2329.114-1248.386-2330.906-1248.405-2332.876-1248.405Z",
    transform: "translate(2355.41 1297.36)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -2355.41, -1377.7)",
    filter: "url(#Trac\\xE9_327)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_327-2",
    "data-name": "Trac\\xE9 327",
    d: "M-2208.836-1283.11l-3.73,3.57c-3.7-3.632-7.9-5.2-12.9-3.285-2.17.83-3.578,2.491-4.781,4.757h13.212c-.729,2.38-1.094,2.675-3.206,2.678-3.531,0-7.062,0-10.563,0-.655,1.8-.507,2.019,1.294,2.019h12.491c-.857,2.5-1.069,2.66-3.4,2.66l-8.712-.006h-1.365c.453,3.335,3.857,6.143,8.067,6.658,3.956.484,7.09-1.266,9.81-4.1l3.671,3.866a16.155,16.155,0,0,1-13.238,5.535c-7.181-.379-11.9-4.142-14.039-11.135a1.447,1.447,0,0,0-1.006-.777,17.782,17.782,0,0,0-2.519-.036c.607-2.126,1.043-2.52,3.069-2.782.031-.541.064-1.109.108-1.859h-3.175c.571-2.112,1.064-2.5,2.9-2.762a1.5,1.5,0,0,0,.989-.868c3.2-9.9,17.488-14.1,26.492-4.828A7.708,7.708,0,0,1-2208.836-1283.11Z",
    transform: "translate(2275.69 1315.87)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChiffreAffaireIcon);
export default __webpack_public_path__ + "static/media/chiffre-affaire-icon.75b9608ae87957ad4ebdef1b0c783add.svg";
export { ForwardRef as ReactComponent };